/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const timelineData = [
    {
        color: 'info',
        icon: 'inventory',
        title: 'SE RECIBE ORDEN DE COMPRA PROYECTO TAR 2024',
        dateTime: '23-01-2024 12:25:24',
        description: 'Carla Chiappini',
    },
    {
        color: 'success',
        icon: 'check_circle',
        title: 'SE RECIBE WR 318869 ITEM 1 Y 2 COMPLETA',
        dateTime: '20-03-2024 15:34:41',
        description: 'Carla Chiappini',
    },
    {
        color: 'warning',
        icon: 'local_shipping',
        title: 'SE RECIBE ORDEN Y SE CONSULTA ESTADO CON PROVEEDOR',
        dateTime: '22-01-2024 14:44:08',
        description: 'Carla Chiappini',
    },
    {
        color: 'primary',
        icon: 'flight_takeoff',
        title: 'EMBARQUE AÉREO OP 22792',
        dateTime: '17-01-2024',
        description: 'Carla Chiappini',
    },
    {
        color: 'error',
        icon: 'cancel',
        title: 'SE DETECTAN DISCREPANCIAS EN EL EMBARQUE',
        dateTime: '25-01-2024 11:15:30',
        description: 'Carla Chiappini',
    },
    {
        color: 'secondary',
        icon: 'update',
        title: 'EMBARQUE RETRASADO',
        dateTime: '28-01-2024 10:00:00',
        description: 'Carla Chiappini',
    },
    {
        color: 'success',
        icon: 'check_circle',
        title: 'EMBARQUE COMPLETADO Y ENTREGADO',
        dateTime: '30-01-2024 09:30:00',
        description: 'Carla Chiappini',
        lastItem: true,
    },
];

export default timelineData;
